import { createSelector } from 'reselect';

export const identifcationVerificationSelector = (state) =>
  state.identificationVerification;

export const selectFundingSource = createSelector(
  identifcationVerificationSelector,
  (identificationVerification) =>
    identificationVerification?.identificationTypesSources || [],
);

export const selectIdentificationInfoDetails = createSelector(
  identifcationVerificationSelector,
  (state) => state.identificationInfoDetails,
);
